import { AlertTriangle, RadioTower } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../api";
import { Brand } from "../components/Brand";
import { PublicInventoryRecord } from "../components/PublicInventoryRecord";
import type { InventoryUnit } from "../types";

export function TagLandingPage() {
  const { token = "" } = useParams();
  const [state, setState] = useState<Record<string, unknown> | null>(null);

  useEffect(() => {
    api.resolveTag(token).then(setState);
  }, [token]);

  if (!state) return <div className="loading-screen">Reading NFC tag…</div>;
  const status = String(state.state);
  if (status === "active" && state.unit) {
    return (
      <PublicInventoryRecord
        unit={state.unit as InventoryUnit}
        canEdit={Boolean(state.can_edit)}
      />
    );
  }

  const unassigned = status === "unassigned";
  const authenticationRequired = status === "authentication_required";
  return (
    <div className="tag-state-page">
      <Brand />
      <div className={`tag-state-icon ${unassigned ? "blue" : "amber"}`}>
        {unassigned ? <RadioTower /> : <AlertTriangle />}
      </div>
      <h1>{String(state.message || "Invalid tag")}</h1>
      <p>
        {authenticationRequired
          ? "This household inventory is private. Sign in to open the scanned record."
          : unassigned
          ? "This secure tag is known but has not been attached to an inventory record."
          : "This token cannot open an active inventory record. It was not used to create a new record."}
      </p>
      {unassigned && state.can_register ? (
        <Link className="button primary full" to={`/inventory/new?tag=${encodeURIComponent(token)}`}>
          Register this tag
        </Link>
      ) : (
        <Link
          className="button primary full"
          to="/login"
          state={{ from: { pathname: `/tag/${token}` } }}
        >
          Administrator login
        </Link>
      )}
      <Link className="button secondary full" to="/">
        Return to dashboard
      </Link>
    </div>
  );
}
